var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-button',{staticClass:"verify-code-button",attrs:{"type":"primary","size":"mini","round":"","disabled":_vm.disabled,"loading":_vm.loading,"loading-text":"获取中","native-type":"button"},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.disabled ? `${_vm.lefTime}s后获取` : _vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }